@if (creatorId()) {
  <div class="h-full min-h-0 overflow-y-auto scrollbar-transparent">
    <admin-tool-super-socials class="block h-full" [creatorId]="creatorId()!" />
  </div>
}
